import { render, staticRenderFns } from "./Candles.vue?vue&type=template&id=bf8df554&scoped=true"
import script from "./Candles.vue?vue&type=script&lang=js"
export * from "./Candles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8df554",
  null
  
)

export default component.exports